// extracted by mini-css-extract-plugin
export default {"iconsMouse":"BlinkingText_iconsMouse__77umn","blink":"BlinkingText_blink__DpP5S","icon":"BlinkingText_icon__jJKkb","iconText":"BlinkingText_iconText__8Q9q2"};